import React, { createContext, useState } from 'react';
export const defaultCommentState = {
  setDraft: () => undefined,
  activeCommentId: undefined,
  setActiveComment: () => undefined
};
export const CommentStateContext = /*#__PURE__*/createContext(defaultCommentState);
export const CommentStateProvider = _ref => {
  let {
    children
  } = _ref;
  const [draft, setDraft] = useState();
  const [activeCommentId, setActiveComment] = useState();
  return /*#__PURE__*/React.createElement(CommentStateContext.Provider, {
    value: {
      draft,
      setDraft,
      activeCommentId,
      setActiveComment
    }
  }, children);
};
//# sourceMappingURL=comment-states.js.map